import { Box, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  onClick: () => void;
}

const CreditInvoiceSnackbarContent = ({ onClick }: Props) => {
  const { t } = useTranslation("invoices");

  return (
    <Box display="flex" flexDirection="row" gap="0.75rem">
      <Typography
        sx={{
          fontFamily: "Source Sans Pro",
          fontWeight: 400,
          fontSize: "14px",
        }}
      >
        {t("invoicesCreated")}
      </Typography>
      <Link
        component="button"
        onClick={onClick}
        sx={{
          fontFamily: "Quicksand",
          fontWeight: 700,
          fontSize: "14px",
          color: "rgba(162, 115, 225, 1)",
          textDecoration: "none",
        }}
      >
        {t("checkInvoices")}
      </Link>
    </Box>
  );
};

export default CreditInvoiceSnackbarContent;
